'use client'
import { HTMLAttributes, PropsWithChildren, RefObject, useRef, useState } from 'react'
import styles from './PlaceholderTopNav.module.scss'
import { classNames } from '@/src/helpers/component'
import useWindowScroll from '@/src/hooks/useWindowScroll'

export interface PlaceholderTopNavProps extends HTMLAttributes<HTMLDivElement> {
  ref?: RefObject<HTMLDivElement | null>
}

export default function PlaceholderTopNavClient({
  ref,
  children,
}: PropsWithChildren<PlaceholderTopNavProps>) {
  const [isStuck, setIsStuck] = useState(false)
  const _ref = useRef<HTMLDivElement>(null)
  useWindowScroll(y => setIsStuck(y >= _ref.current!.clientHeight))
  return (
    <div
      ref={e => {
        if (!e) return
        _ref.current = e
        if (ref) ref.current = e
      }}
      className={classNames(styles.container, isStuck ? styles.stuck : '')}>
      {children}
    </div>
  )
}
